import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '91免费平台上的视频资源是否完全免费？',
    answer: '是的，91免费平台上的所有视频资源均为免费观看，无需付费会员即可畅享高清画质。我们致力于为广大用户提供优质、便捷的免费在线观影体验，让每个人都能轻松享受影视娱乐。',
  },
  {
    question: '平台支持哪些设备观看？',
    answer: '91免费平台全面支持PC端、平板和手机等多种设备观看。只需打开浏览器访问我们的网站，即可随时随地享受高清观影。我们采用了先进的流媒体技术，确保在不同设备上都有流畅的播放体验。',
  },
  {
    question: '视频画质清晰吗？支持1080P和4K吗？',
    answer: '我们提供多种画质选择，包括高清720P、超清1080P以及部分影片支持4K超高清画质。您可以根据网络状况和个人偏好自由切换画质，确保最佳观影体验。系统会根据您的网络带宽自动推荐合适的画质。',
  },
  {
    question: '平台上的资源多久更新一次？',
    answer: '91免费平台每天更新最新的影视资源，确保您能够第一时间观看到最新的热门电影和剧集。我们的内容团队全天候监控各大片源，一旦有新资源上线，会尽快为您更新。',
  },
  {
    question: '观看视频需要注册账号吗？',
    answer: '不需要！91免费平台无需注册即可直接观看所有视频内容。我们致力于提供最简单、最便捷的观影体验，打开网站即可开始观看，没有任何繁琐的注册流程。',
  },
  {
    question: '遇到播放问题该如何解决？',
    answer: '如果遇到播放卡顿或无法播放的情况，建议您：1）检查网络连接是否稳定；2）尝试切换较低画质；3）刷新页面重新加载；4）清除浏览器缓存后重试。如问题持续，请联系我们的客服团队获取帮助。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于91免费平台的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 overflow-hidden bg-background-50 transition-all duration-300"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}